import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";
import {
  FaAngleDown,
  FaMobileAlt,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import Logo from "../../images/logo1.png";
import "./style.css";

const menus = [
  {
    id: 4,
    title: "Services",
    link: "#",
    submenu: [
      {
        id: 401,
        title: "Business setup, Assurance & Compliance Support",
        link: "#",
        submenu: [
          {
            id: 21,
            title: "1. Set Up Your Business",
            link: "#",
            submenu: [
              {
                id: 211,
                title: "Set Up Your Business in India",
                link: "/service-category/setUpYourBusinessInIndia",
              },
              {
                id: 212,
                title: "India Entry & Structuring",
                link: "/services/indiaEntryAndEntityStructuring",
              },
              {
                id: 213,
                title: "FEMA & Cross-Border Advisory",
                link: "/services/femaAndCrossBorderAdvisory",
              },
              {
                id: 214,
                title: "Business registrations, approvals & licenses",
                link: "/services/businessRegistrationsApprovalsAndLicenses",
              },
            ],
          },
          {
            id: 22,
            title: "2. Audit & Assurance",
            link: "#",
            submenu: [
              {
                id: 221,
                title: "Statutory, tax & internal audits",
                link: "/services/statutoryTaxAndInternalAudits",
              },
              { id: 222, title: "Management & operational audits", link: "#" },
              { id: 223, title: "IFC design & risk review", link: "#" },
              { id: 224, title: "Compliance & process assessments", link: "#" },
            ],
          },
          {
            id: 23,
            title: "3. Taxation & Regulatory",
            link: "#",
            submenu: [
              {
                id: 231,
                title: "Direct & indirect tax advisory",
                link: "/services/directAndIndirectTaxAdvisory",
              },
              {
                id: 232,
                title: "GST compliance & litigation support",
                link: "/services/gstComplianceAndLitigationSupport",
              },
              {
                id: 233,
                title: "International taxation & transfer pricing",
                link: "#",
              },
              { id: 234, title: "Tax structuring & optimization", link: "#" },
            ],
          },
          {
            id: 24,
            title: "4. Accounting & Business Support",
            link: "#",
            submenu: [
              {
                id: 241,
                title: "Outsourced bookkeeping",
                link: "/services/outsourcedBookkeeping",
              },
              { id: 242, title: "MIS & management reporting", link: "#" },
              { id: 243, title: "Financial process automation", link: "#" },
              {
                id: 244,
                title: "Managed Payroll & People Compliance",
                link: "#",
              },
              { id: 245, title: "IFRS / Ind-AS accounting support", link: "#" },
            ],
          },
          {
            id: 25,
            title: "5. Corporate Secretarial & Governance",
            link: "#",
            submenu: [
              {
                id: 251,
                title: "Corporate law & secretarial advisory",
                link: "/services/corporateLawAndSecretarialAdvisory",
              },
              {
                id: 252,
                title: "ROC filings & statutory registers",
                link: "#",
              },
              {
                id: 253,
                title: "Board & shareholder governance support",
                link: "#",
              },
              {
                id: 254,
                title: "FEMA/RBI compliance for foreign-owned entities",
                link: "#",
              },
            ],
          },
        ],
      },
      {
        id: 402,
        title: "Advisory & Deals",
        link: "#",
        submenu: [
          {
            id: 31,
            title: "1. IPO & Capital Markets Readiness",
            link: "#",
            submenu: [
              {
                id: 311,
                title: "IPO Readiness Assessment",
                link: "/services/iPOReadinessAssessment",
              },
              { id: 312, title: "Financial Statement Restatement", link: "#" },
              { id: 313, title: "Internal controls setup", link: "#" },
              {
                id: 314,
                title: "Coordination with Merchant Bankers",
                link: "#",
              },
            ],
          },
          {
            id: 32,
            title: "2. Transaction Advisory, Due Diligence & Valuations",
            link: "#",
            submenu: [
              {
                id: 321,
                title: "Mergers & Acquisitions (M&A) Support",
                link: "/services/mAndASupportAndDueDiligence",
              },
              { id: 322, title: "Due diligence", link: "#" },
              {
                id: 323,
                title: "Business valuation & financial modeling",
                link: "/services/businessValuationAndFinancialModeling",
              },
              {
                id: 324,
                title: "Fundraising & deal structuring",
                link: "/services/fundraisingAndDealStructuring",
              },
            ],
          },
          {
            id: 33,
            title: "3. Management Consulting",
            link: "#",
            submenu: [
              {
                id: 331,
                title: "Business strategy & transformation",
                link: "/services/businessStrategyAndTransformation",
              },
              { id: 332, title: "Performance improvement", link: "#" },
              {
                id: 333,
                title: "Risk management & internal controls",
                link: "#",
              },
              {
                id: 334,
                title: "Digital transformation advisory",
                link: "/services/digitalTransformationAdvisory",
              },
            ],
          },
          {
            id: 34,
            title: "4. ESG & Sustainability Consulting",
            link: "#",
            submenu: [
              {
                id: 341,
                title: "ESG reporting & disclosures",
                link: "/services/eSGReportingAndDisclosures",
              },
              { id: 342, title: "Sustainability strategy", link: "#" },
              { id: 343, title: "CSR compliance advisory", link: "#" },
            ],
          },
          {
            id: 35,
            title: "5. Virtual CFO services",
            link: "#",
            submenu: [
              {
                id: 351,
                title: "Strategic financial leadership",
                link: "/service-category/virtualCfoServices",
              },
              { id: 352, title: "Board-level financial advisory", link: "#" },
              { id: 353, title: "Business performance review", link: "#" },
              {
                id: 354,
                title: "Capital allocation & cash-flow planning",
                link: "#",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 8,
    title: "About Us",
    link: "/about",
  },
  {
    id: 5,
    title: "Knowledge Bank",
    link: "/knowledge-bank",
    submenu: [
      {
        id: 51,
        title: "Calculators",
        link: "/calculator",
      },
      {
        id: 52,
        title: "Links",
        link: "/links",
      },
      {
        id: 53,
        title: "Acts",
        link: "/acts",
      },
    ],
  },
  {
    id: 6,
    title: "Careers",
    link: "/career",
    submenu: [
      {
        id: 61,
        title: "Why Join Us",
        link: "/whyJoinUs",
      },
      {
        id: 62,
        title: "Current Openings",
        link: "/currentOpenings",
      },
      {
        id: 63,
        title: "Testimonial",
        link: "/testimonials",
      },
      {
        id: 64,
        title: "Apply Now",
        link: "/applyNow",
      },
    ],
  },
  {
    id: 7,
    title: "Contact",
    link: "/contact",
  },
];

const MenuItem = ({ item, level = 0, clickHandler }) => {
  const [open, setOpen] = useState(false);
  const hasSubmenu = item.submenu && item.submenu.length > 0;

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!open);
  };

  return (
    <ListItem className={`${open ? "active" : ""}`}>
      <div className="menu-item-wrapper">
        <Link
          to={item.link === "#" ? null : item.link}
          className={`menu-item-link ${item.link === "#" ? "disabled" : ""}`}
          onClick={() => {
            if (item.link && item.link !== "#") {
              clickHandler();
            }
          }}
        >
          {item.title}
        </Link>
        {hasSubmenu && (
          <div className="submenu-toggle-btn" onClick={handleToggle}>
            <FaAngleDown className={`toggle-icon ${open ? "rotate" : ""}`} />
          </div>
        )}
      </div>
      {hasSubmenu && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List className="subMenu">
            {item.submenu.map((subitem, index) => (
              <MenuItem
                key={subitem.id || index}
                item={subitem}
                level={level + 1}
                clickHandler={clickHandler}
              />
            ))}
          </List>
        </Collapse>
      )}
    </ListItem>
  );
};

const MobileMenu = ({ isSticky }) => {
  const [menuActive, setMenuState] = useState(false);

  const ClickHandler = () => {
    setMenuState(false);
    window.scrollTo(0, 0);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
        <div className="mobile-header">
          <div className="mobile-logo">
            <img src={Logo} alt="Logo" />
          </div>
          <div className="mobile-close-btn" onClick={() => setMenuState(false)}>
            <IoCloseOutline size={24} />
          </div>
        </div>

        <div className="mobile-menu-body">
          <ul className="responsivemenu">
            {menus.map((item, index) => (
              <MenuItem
                key={item.id || index}
                item={item}
                clickHandler={ClickHandler}
              />
            ))}
          </ul>
        </div>

        <div className="mobile-footer">
          <div className="contact-mini">
            <div className="contact-mini-item">
              <FaMobileAlt /> <span>+91 99996 32411</span>
            </div>
            <div className="contact-mini-item">
              <FaEnvelope /> <span>admin@vdoogar.com</span>
            </div>
          </div>
          <div className="social-mini">
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
        <button
          type="button"
          className={`navbar-toggler ${isSticky ? "sticky-active" : ""}`}
        >
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
